<template lang="pug">
.dropdown-menu(v-if="displayWatchlist")
  .dropdown-content.content
    .dropdown-item
      p.has-text-weight-bold {{ $t("watchlist.watchlist") }}
        span.is-pulled-right.field.has-addons
          .control
            button.button.is-small.is-light(:title="$t('watchlist.addCurrentPage')" @click="addPage")
              i.fa.fa-fw.fa-plus
          .control
            button.button.is-small.is-light(:title="$t('watchlist.clearList')" @click="clear")
              i.fa.fa-fw.fa-trash
          .control
            a.button.is-small.is-light(:title="$t('watchlist.saveList')" :download="watchlistFilename" :href="fileContent")
              i.fa.fa-fw.fa-save
          .control
              label.button.is-small.is-light(for="uploadWatchlist" :title="$t('watchlist.loadList')")
                i.fa.fa-fw.fa-upload
              input(type="file" id="uploadWatchlist" ref="watchlistFile" @change="handleFileUpload()" style="opacity:0;position:absolute;z-index:-1;")
      hr.dropdown-divider
      template(v-if="!empty")
        ol.is-numeric-bracket
          li(v-for="page of sortedWatchlist")
            router-link(:to="page.route")
              span.has-text-primary {{ page.sig }}
            span.is-pulled-right.field.has-addons
              .control
                .button.is-small.is-white(:title="$t('watchlist.removePage')" @click="removePage(page)"): i.fa.fa-fw.fa-minus-square-o
              .control
                .button.is-small.is-white(:title="$t('watchlist.moveUp')" @click="moveUp(page)"): i.fa.fa-fw.fa-angle-up
              .control
                .button.is-small.is-white(:title="$t('watchlist.moveDown')" @click="moveDown(page)"): i.fa.fa-fw.fa-angle-down
      .dropdown-item.empty-watchlist(v-else)
        p(v-html="$t('watchlist.empty')")
</template>

<script>
const { messages } = require("../i18n/watchlist");
const { mapGetters, mapMutations, mapState } = require("vuex");
const { platform } = navigator;
const newLineCharacter = determineNewLineChar();
const toc = require("../helpers/toc");

export default {
    name: "Watchlist",
    i18n: { messages },
    computed: {
        empty() {
            return !this.watchlist || Object.keys(this.watchlist).length === 0
        },

        fileContent() {
            const contentBuilder = [];
            contentBuilder.push("data:text/plain;charset=utf-8,");
            contentBuilder.push(this.$t("watchlist.title") + newLineCharacter);
            contentBuilder.push(this.$t("watchlist.watchlist") + newLineCharacter + newLineCharacter);

            for (const item of this.sortedWatchlist) {
                const URL = this.fullUrl(item);
                contentBuilder.push(`- [${item.sig}] ${item.title}: ${URL} [${item.id}]` + newLineCharacter);
            }

            return contentBuilder.join("");
        },

        sortedWatchlist() {
            return Object.keys(this.watchlist).map(p => { return this.watchlist[p] }).sort(compareWatchlistItems)
        },

        watchlistFilename() {
            return this.$t("watchlist.filename", { timestamp: Date.now() });
        },

        ...mapState("transcript", ["displayWatchlist", "watchlist"])
    },

    methods: {
        addPage() {
            this.addPageToWatchlist(this.current());
        },

        clear() {
            this.$dialog.confirm({
                message: this.$t("watchlist.confirmDeletion"),
                onConfirm: () => this.clearWatchList()
            })
        },

        fullUrl(page) {
            const resolvedRoute = this.$router.resolve(page.route)
            return window.location.origin + resolvedRoute.href;
        },

        handleFileUpload() {
            const file = this.$refs.watchlistFile.files[0];
            const reader = new FileReader();
            reader.onload = this.parseUploadedWatchlist;
            reader.readAsText(file);
        },

        moveDown(page) {
            this.moveWatchlistItemDown(page);
        },

        moveUp(page) {
            this.moveWatchlistItemUp(page);
        },

        parseUploadedWatchlist(event) {
            const newWatchlist = {};
            let seq = 1;
            const lines = event.target.result.split(/[\r\n]+/).map((l) => { return l.match(/ \[([^[]+)\]$/)}).filter((l) => { return l });
            for(const l of lines) {
                const route = { name: "transcript", params: { section: "edition", id: l[1] }};
                let entry = toc.node( route );
                if(entry) {
                    entry = Object.assign({id: route.params.id, route, seq}, entry);
                    if(entry.parent) {
                        // we need to remove parent references because vuex-persistedstate uses JSON.stringify, which cannot handle circular references
                        delete entry.parent;
                    }
                    newWatchlist[l[1]] = entry;
                    seq++;
                } else {
                    console.error("node for id " + l[1] + " not found");
                }
            }
            if(Object.keys(newWatchlist).length > 0) {
                this.setWatchlist(newWatchlist);
            } else {
                this.$dialog.alert({
                    message: this.$t("watchlist.uploadFailed")
                })
            }
            this.$refs.watchlistFile.value = "";
        },

        removePage(page) {
            this.removePageFromWatchlist(page);
        },

        save() {

        },

        ...mapGetters("toc", ["current"]),
        ...mapMutations("transcript", ["addPageToWatchlist", "clearWatchList", "moveWatchlistItemDown", "moveWatchlistItemUp", "removePageFromWatchlist", "setWatchlist", "toggleWatchlistDisplay"])

    }
}

function compareWatchlistItems(a, b) {

    if (a.seq < b.seq) {
        return -1;
    }
    if (a.seq > b.seq) {
        return 1;
    }
    return 0;
}

function determineNewLineChar() {
    if(isWin) return "\r\n";
    return "\n";
}

function isWin() {
    return platform.startsWith("Win");
}
</script>